import React from "react";
import { Form, Button, Spinner, Stack } from "react-bootstrap";
import "../assets/css/myStyle.css";
import NavigasiBar from "./NavigasiBar";

const DeleteArticlePage = (
    {
        articles,
        loading,
        articleId,
        handleInputChangeId,
        handleSubmit
    }
) => {
    return(
        <Stack gap={2}>
            <NavigasiBar/>
            <div className="headerDelete">
                <div className="display-2 mb-2 fw-bold">Delete Kenangan</div>
            </div>
            <Form className="mb-4 mt-4" onSubmit={handleSubmit}>
                <div className="cardForm align-self-center">
                    <Form.Group className="d-flex flex-column align-items-center mb-2">
                        <Form.Label className="me-2 mb-4 fontJudul fw-semibold align-self-center">
                            Masukkan ID pada kolom dibawah untuk mendelete kenangan yang ada
                        </Form.Label>
                        <Form.Control className="formControl" placeholder="Tulis id"
                                        value={articleId}
                                        onChange={(evt)=>handleInputChangeId(evt.currentTarget.value)}/>
                    </Form.Group>
                    <Button type="submit" className="submitButton w-75 mt-3 mb-3">Submit</Button>
                </div>
            </Form>
            <hr />
            {
                loading
                ?
                <Spinner animation="grow" />
                :
                articles.map((article) => (
                    <div className="mb-2 cardItems card">
                        <div className="card-body w-100">
                            <div className="d-flex align-self-start" key={article.id}>
                                <div className="idItems">ID: {article.id}</div>
                                <div className="judulItems"><span>{article.title}</span></div>
                                <div className="ratingItems"> Rating : <span className="rating">{article.rating}</span></div>
                                
                            </div>
                        </div>
                    </div>
                ))
            }
        </Stack>
    );
}

export default DeleteArticlePage;